module.exports = __webpack_public_path__ + "static/main_bg-93f9a03fa26ae0b439c9e5d2df38e729.jpg";